/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import PropTypes from "prop-types";
import React from "react";
import Icon from "../Icon";
import styles from "./bread_crumbs.module.scss";

class BreadCrumbs extends React.Component {
   content_maping=(items)=>{
    const result =  items.map(( item, index)=>{
    if(index === 0 && items.length !== 1){
      return <li><a href={item.url}>{item.display}</a></li>
     }else{
      return [
            <li className="crumb">
              <Icon
                name="crumb"
                fileName="chevron-next-18"
                title="Chevron Next"
              />
          </li>,
          <li>
            <a href={item.url}>{item.display}</a>
          </li>
          ]
    }

  })
  return result
  }
  render() {
    return (
      <nav aria-label="Breadcrumb">
        <ul className={styles.breadcrumbs}>{this.content_maping(this.props.items)}</ul>
      </nav>
    );
  }
}

BreadCrumbs.propTypes = {
  items: PropTypes.array.isRequired,
};

export default BreadCrumbs;
